import React, { useEffect } from 'react'
import { Box, Stack } from '@mui/material'
import { Avatar } from './Avatar'
import { useTheme } from '@mui/material/styles'
import { useParams } from 'react-router-dom'
import api from '../services/api'
import { showMessage } from '../redux/reducers/snackbar/snackbar.actions'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { useTranslation } from 'react-i18next'
import { RootState } from 'redux/rootReducer'
import { ProfessionalAthlete } from 'models/interfaces/professional-athlete.interface'
import { setSummaryProfessionalAthlete } from 'redux/reducers/summary-athlete/actions'

export const SummaryAthleteSelected = () => {
  const { palette } = useTheme()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { professionalAthleteId } = useParams()
  const { reload, professionalAthlete } = useAppSelector((state: RootState) => state.summaryAthlete)

  useEffect(() => {
    dataFetch().catch(console.error)
  }, [reload])

  const dataFetch = async () => {
    if (professionalAthleteId && professionalAthlete?.id !== professionalAthleteId) {
      await findProfessionAthlete(professionalAthleteId)
    }
  }

  const findProfessionAthlete = async (professionalAthleteId: string) => {
    try {
      const { data } = await api.get(`professional-athletes/${professionalAthleteId}`)
      const professionalAthlete = data as ProfessionalAthlete
      dispatch(setSummaryProfessionalAthlete(professionalAthlete))
    } catch (e) {
      dispatch(showMessage({ message: `${t('general.error')}`, type: 'error' }))
    }
  }

  return (
    <Stack direction="row" spacing={2} p={2} px={3} bgcolor="grey.800" borderRadius={1}>
      <Avatar
        imagePath={professionalAthlete?.athlete.imagePath}
        name={professionalAthlete?.athlete.name}
        size={60}
        border={3}
      />
      <Box justifyContent="center" sx={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 'bold', color: palette.grey[200] }}>
          {professionalAthlete?.athlete.name} {professionalAthlete?.athlete.surname}
        </span>
        <span style={{ color: palette.grey[400] }}>{professionalAthlete?.athlete.email}</span>
      </Box>
    </Stack>
  )
}
